import { NgModule } from '@angular/core';
import { RouterModule, ActivatedRouteSnapshot } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

import { menu } from './menu';
import { routes, externalUrlProvider } from './routes';
import { MenuService } from '../core/services/menu.service';
import { ErrorsModule } from './errors/errors.module';

@NgModule({
  imports: [
    SharedModule,
    ErrorsModule,
    RouterModule.forRoot(routes)
  ],
  declarations: [],
  exports: [
    RouterModule,
    ErrorsModule
  ],
  providers: [{
    provide: externalUrlProvider,
    useValue: (route: ActivatedRouteSnapshot) => {
      console.log('dd');
      const externalUrl = route.paramMap.get('externalUrl');
      window.open(externalUrl, '_blank');
    }
  }]
})

export class RoutesModule {
  constructor(public menuService: MenuService) {
    // menuService.populate();
  }
}
